import { render, staticRenderFns } from "./AudioSpotTableItem.vue?vue&type=template&id=2d533f24&scoped=true&"
import script from "./AudioSpotTableItem.vue?vue&type=script&lang=ts&"
export * from "./AudioSpotTableItem.vue?vue&type=script&lang=ts&"
import style0 from "./AudioSpotTableItem.vue?vue&type=style&index=0&id=2d533f24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d533f24",
  null
  
)

export default component.exports